














































import Component from 'vue-class-component'
import { Vue, Prop, Watch } from 'vue-property-decorator'
import Delivery from '@/dto/deliveries/Delivery'
import DictionariesService from '@/services/DictionariesService'
import Preferences from '@/components/delivery/Preferences.vue'
import Zones from '@/components/delivery/Zones.vue'
import Tariffs from '@/components/delivery/Tariffs.vue'
import DeliveryPoints from '@/components/delivery/DeliveryPoints.vue'
import MarkupsTable from '@/components/delivery/markups/MarkupsTable.vue'

@Component({
  components: { MarkupsTable, DeliveryPoints, Tariffs, Zones, Preferences },
})
export default class DeliveryForm extends Vue {
  @Prop(Object)
  model: Delivery
  dictionariesService = DictionariesService
  currentTab: string = 'preferences'
  tabs = {
    preferences: 'Настройки',
    rates: 'Тарифы',
    zones: 'Зоны',
    points: 'Пункты выдачи',
    markups: 'Наценки',
  }

  get allowedTabs() {
    const allowedTabs = {
      preferences: this.tabs.preferences,
    }
    const tabsForDelivery = this.dictionariesService.getTabsForDelivery(
      this.model
    )

    if (tabsForDelivery === null) {
      return { ...allowedTabs, markups: this.tabs.markups }
    }

    return { ...allowedTabs, ...tabsForDelivery, markups: this.tabs.markups }
  }

  created() {
    const savedCurrentTab = localStorage.getItem('deliveryTab')

    if (
      savedCurrentTab &&
      this.isEnabledTab(savedCurrentTab) &&
      savedCurrentTab in this.allowedTabs
    ) {
      this.currentTab = savedCurrentTab
    } else {
      this.currentTab = 'preferences'
    }
  }

  isEnabledTab(tabName: string) {
    return tabName === 'preferences' || this.model.id !== null
  }

  @Watch('model')
  resetCurrentTab() {
    if (
      !(this.currentTab in this.allowedTabs) ||
      !this.isEnabledTab(this.currentTab)
    ) {
      this.currentTab = 'preferences'
    }
  }

  @Watch('currentTab')
  localSaveTab(currentTab: string) {
    localStorage.setItem('deliveryTab', currentTab)
  }
}
